import classNames from 'classnames';
import React from 'react';
import FadeIn from 'react-fade-in';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import Lottie from 'react-lottie-player';
import { useParams } from 'react-router-dom';
import animationData from '../../components/load/not-found.json';
import { usePageview } from '../../hooks/use-pageview';

function NotFound({ className }) {
  const { menuSlug } = useParams();
  const { t } = useTranslation();
  const classes = useStyles();

  usePageview('Not Found');

  return (
    <div className={classes.container}>
      <FadeIn>
        <Lottie
          loop
          play
          animationData={animationData}
          style={{ width: 300, height: 300 }}
        />
        <div className={classNames(classes.text, className)}>
          {t('not-found.message_1')}
          <span className={classes.slug}>{menuSlug}</span>
          {t('not-found.message_2')}
        </div>
      </FadeIn>
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    color: 'white',
    position: 'absolute',
    flexDirection: 'column',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    justifyContent: 'center',
    alignItems: 'center',
    // border: '1px solid yellow',
  },
  text: {
    alignContent: 'center',
    textAlign: 'center',
    // border: '1px solid red',
  },
  slug: {
    fontWeight: 'bolder',
    color: '#F9A692',
    // textDecoration: 'underline',
  },
});

export { NotFound };
